angular.module('ad3').directive 'd3Overlay', ->
  defaults = ->
    duration: 200

  restrict: 'A'
  require: '^d3Chart'
  scope: true

  link: ($scope, $el, $attrs, chartCtrl) ->
    options = angular.extend(defaults(), $attrs)
    xscale = chartCtrl.getScale(options.x)
    yscale = chartCtrl.getScale(options.y)
    focus = null

    positionFocus = (e) =>
      return unless focus
      focus.classed { 'active': true }
      isActive = if $scope.active then 1 else 0
      $scope.active = true
      pos = d3.mouse(e)
      xval = xscale.invert(pos[0] - chartCtrl.margin.left)
      yval = yscale.invert(pos[1] - chartCtrl.margin.top)
      data = if options.map
        $scope.$eval(options.map, { x: xval, y: yval })
      else
        [xval, yval]
      xpos = $scope.xpos = xscale(data[0])
      ypos = $scope.ypos = yscale(data[1])
      $scope.outerXPos = xpos + chartCtrl.margin.left
      $scope.outerYPos = ypos + chartCtrl.margin.top
      focus.select('circle')
        .transition().duration(isActive * options.duration)
        .attr("transform", "translate(" + xpos + "," + ypos + ")")
      focus.select('line.x')
        .transition().duration(isActive * options.duration)
        .attr("transform", "translate(" + xpos + ",0)")
        .attr('y2', ypos)
      focus.select('line.y')
        .transition().duration(isActive * options.duration)
        .attr("transform", "translate(0," + ypos + ")")
        .attr('x2', xpos)
      $scope.$apply()

    redraw = ->
      chart = chartCtrl.getChart()
      unless focus?
        focus = chart.append('g').attr('class', 'focus')
        focus.append("line").attr("class", "x")
        focus.append("line").attr("class", "y")
        focus.append("circle").attr("r", 5)
      focus.select('line.y').attr("x1", 0)
      focus.select('line.x').attr("y1", chartCtrl.innerHeight)
      $scope.hide()

    if $attrs.click is 'true'
      chartCtrl.getSvg().on('click', -> positionFocus(this))
    else
      chartCtrl.getSvg().on('mousemove', -> positionFocus(this))

    chartCtrl.registerElement(redraw, $attrs.order or 1000)

    $scope.hide = ->
      focus.classed { 'active': false } if focus
      $scope.active = false
